import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Button, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { CPDHomeownerTrap, CPDSuccessScreen, CPDPrelanding } from 'shared/components/CPD';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { ICPDPrelandingConfig } from 'shared/containers/valuationTraps/HomeownerTrap/CPDHomeownerTrap/types';
import { useCPDProps } from 'shared/containers/valuationTraps/hook/useCPDProps';
import { useCpdTracking } from 'shared/containers/valuationTraps/utils/tracking/cpd';
import { ECpdDraftStatus } from 'shared/types/cpd/cpd';

export const CPDHomeownerTrapContainer: React.FC = () => {
  const {
    cpdDraftStatus,
    cpdDraftId,
    offer,
    isModalOpen,
    onTrapClick,
    onGoCianChat,
    onCloseTrapModal,
    onCreateDraftCpd,
    isMarketingAgreement,
    handleChangeMarketingAgreement,
  } = useCPDProps(true);
  const { trackCPDTrapVisible } = useCpdTracking(true);

  const { config } = useApplicationContext();
  const prelandingContent = config.get<ICPDPrelandingConfig>('CPDPrelandingData');

  if (!prelandingContent?.homeowner) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackCPDTrapVisible} callbackDelay={1000}>
      <>
        <CPDHomeownerTrap onClick={onTrapClick} />
        <ModalWindow
          header={<div />}
          open={isModalOpen}
          onClose={onCloseTrapModal}
          content={
            cpdDraftStatus === ECpdDraftStatus.success ? (
              <CPDSuccessScreen
                cpdDraftId={cpdDraftId}
                isHomeowner
                successButton={
                  <Button onClick={() => onGoCianChat(cpdDraftId)} theme="fill_primary">
                    Подробности — в чате Циан
                  </Button>
                }
              />
            ) : (
              <CPDPrelanding
                cpdDraftStatus={cpdDraftStatus}
                onCreateDraftCpd={onCreateDraftCpd}
                prelandingContent={prelandingContent.homeowner}
                isMarketingAgreement={isMarketingAgreement}
                handleChangeMarketingAgreement={handleChangeMarketingAgreement}
                cpdLandingLink={
                  prelandingContent.homeowner.secondaryBtn &&
                  `${prelandingContent.homeowner.secondaryBtn.url}?cian_source=homeownerOffer_web&offerCategory=${offer.category}`
                }
              />
            )
          }
          size="XS"
          width={540}
        />
      </>
    </ActionAfterViewObserver>
  );
};
